<template>
    <div class="container  pull-up">
        <div class="row">
            <div class="col-lg-12">

                <div class="card m-b-30 ">
                    <div class="card-header">
                        <p class="m-b-0 opacity-50">
                            {{ $t('text.fields_with') }}
                            <req/>
                            {{ $t('text.are_required') }}
                        </p>
                        <hr>
                    </div>
                    <div class="card-body ">
                        <el-form label-position="left" ref="form" :rules="rules" :model="form" label-width="120px">
                            <el-form-item :label="$t('supplier.label.name')" prop="name">
                                <el-input v-model="form.name" :placeholder="$t('supplier.placeholder.name')"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('supplier.label.address')" prop="address">
                                <el-input v-model="form.address" :placeholder="$t('supplier.placeholder.address')"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('supplier.label.phone')" prop="phone">
                                <el-input v-model="form.phone" :placeholder="$t('supplier.placeholder.phone')"></el-input>
                            </el-form-item>

                            <!-- Business Information Section -->
                            <el-divider content-position="left">
                                <i class="el-icon-office-building"></i>
                                {{ $t('supplier.label.business_information') }}
                            </el-divider>

                            <el-collapse v-model="businessInfoExpanded">
                                <el-collapse-item :title="$t('supplier.label.business_information')" name="1">
                                    <el-form-item :label="$t('supplier.label.business_name')" prop="business_name">
                                        <el-input v-model="form.business_name" :placeholder="$t('supplier.placeholder.business_name')"></el-input>
                                    </el-form-item>

                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item :label="$t('supplier.label.tax_id')" prop="tax_id">
                                                <el-input v-model="form.tax_id" :placeholder="$t('supplier.placeholder.tax_id')"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item :label="$t('supplier.label.registration_number')" prop="registration_number">
                                                <el-input v-model="form.registration_number" :placeholder="$t('supplier.placeholder.registration_number')"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>

                                    <el-form-item :label="$t('supplier.label.business_type')" prop="business_type">
                                        <el-select v-model="form.business_type" :placeholder="$t('supplier.placeholder.business_type')" clearable style="width: 100%">
                                            <el-option
                                                v-for="type in businessTypes"
                                                :key="type.value"
                                                :label="type.label"
                                                :value="type.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item :label="$t('supplier.label.website')" prop="website">
                                        <el-input v-model="form.website" :placeholder="$t('supplier.placeholder.website')" type="url"></el-input>
                                    </el-form-item>

                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item :label="$t('supplier.label.contact_person')" prop="contact_person">
                                                <el-input v-model="form.contact_person" :placeholder="$t('supplier.placeholder.contact_person')"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item :label="$t('supplier.label.alternative_phone')" prop="alternative_phone">
                                                <el-input v-model="form.alternative_phone" :placeholder="$t('supplier.placeholder.alternative_phone')"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>

                                    <el-form-item :label="$t('supplier.label.business_address')" prop="business_address">
                                        <el-input
                                            type="textarea"
                                            v-model="form.business_address"
                                            :placeholder="$t('supplier.placeholder.business_address')"
                                            :rows="3">
                                        </el-input>
                                    </el-form-item>

                                    <el-form-item :label="$t('supplier.label.notes')" prop="notes">
                                        <el-input
                                            type="textarea"
                                            v-model="form.notes"
                                            :placeholder="$t('supplier.placeholder.notes')"
                                            :rows="3">
                                        </el-input>
                                    </el-form-item>
                                </el-collapse-item>
                            </el-collapse>

                            <el-form-item class="text-center">
                                <div class="row">
                                    <div class="col-md-6"></div>
                                    <div class="col-md-6">
                                        <el-button type="primary" class="btn-block" :loading="loading" :disabled="loading" @click.prevent="saveSupplier">{{ $t('supplier.button.create') }}</el-button>
                                    </div>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Create',
  data () {
    return {
      loading: false,
      businessInfoExpanded: [],
      form: {
        name: '',
        address: '',
        phone: '',
        business_name: '',
        tax_id: '',
        registration_number: '',
        business_type: '',
        website: '',
        contact_person: '',
        alternative_phone: '',
        business_address: '',
        notes: ''
      },
      businessTypes: [
        { value: 'individual', label: 'Individual' },
        { value: 'company', label: 'Company' },
        { value: 'partnership', label: 'Partnership' },
        { value: 'sole_proprietorship', label: 'Sole Proprietorship' },
        { value: 'other', label: 'Other' }
      ]
    }
  },
  computed: {
    rules () {
      const validateUrl = (rule, value, callback) => {
        if (!value) {
          callback()
          return
        }
        const urlPattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/
        if (!urlPattern.test(value)) {
          callback(new Error(this.$t('supplier.validation.website_invalid')))
        } else {
          callback()
        }
      }

      const validateBusinessType = (rule, value, callback) => {
        if (!value) {
          callback()
          return
        }
        const validTypes = ['individual', 'company', 'partnership', 'sole_proprietorship', 'other']
        if (!validTypes.includes(value)) {
          callback(new Error(this.$t('supplier.validation.business_type_invalid')))
        } else {
          callback()
        }
      }

      return {
        name: [
          { required: true, message: this.$t('supplier.validation.name_required'), trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.$t('supplier.validation.address_required'), trigger: 'blur' }
        ],
        phone: [
          { required: true, message: this.$t('supplier.validation.phone_required'), trigger: 'blur' }
        ],
        website: [
          { validator: validateUrl, trigger: 'blur' }
        ],
        business_type: [
          { validator: validateBusinessType, trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    async saveSupplier () {
      // Guard against concurrent submissions
      if (this.loading) {
        return
      }

      try {
        await this.$refs.form.validate()
      } catch (validationError) {
        // Validation failed - form is invalid, don't submit
        return false
      }

      // Validation passed, proceed with submission
      // this.loading = true
      try {
        // Prepare form data - omit empty optional fields
        const formData = { ...this.form }

        // Remove empty optional business fields to keep payload clean
        const optionalFields = [
          'business_name', 'tax_id', 'registration_number', 'business_type',
          'website', 'contact_person', 'alternative_phone', 'business_address', 'notes'
        ]

        optionalFields.forEach(field => {
          if (!formData[field] || formData[field].trim() === '') {
            delete formData[field]
          }
        })

        const data = await this.$supplierService.create(formData)
        this.showSuccess(this.$t('supplier.message.created'))
        this.$router.push({ name: 'suppliers' })
      } catch (error) {
        // Error is already handled by the global interceptor
        // Error is non-blocking - form remains usable
        console.log('Component caught error in createSupplier:', error)
      } finally {
        // Always reset loading state, regardless of success or failure
        // this.loading = false
      }
    }
  },
  mounted () {
    this.$emit('parent-title', this.$t('supplier.title.create'))
  }
}
</script>

<style scoped>

</style>
